(function () {
  'use strict';

  var SIZE_STEM_FALLBACKS = {
    S: '25',
    M: '51',
    L: '101',
    XL: '151',
    XXL: '501'
  };
  var FREE_DELIVERY_THRESHOLDS = typeof WeakMap !== 'undefined' ? new WeakMap() : null;

  function normalizeSize(value) {
    return String(value || '')
      .trim()
      .toUpperCase()
      .replace(/\s+/g, ' ');
  }

  function localeText() {
    var lang = (document.documentElement.lang || 'en').toLowerCase();
    if (lang.indexOf('ar') === 0) {
      return { label: 'المقاس:', stems: 'ساقاً' };
    }
    if (lang.indexOf('ru') === 0) {
      return { label: 'Размер:', stems: 'стеблей' };
    }
    return { label: 'Size:', stems: 'stems' };
  }

  function selectedVariantId(form) {
    if (!form) return '';
    var idField = form.querySelector('[name="id"]');
    return idField ? String(idField.value || '') : '';
  }

  function selectedSizeValue(root) {
    var checked = root.querySelector('input[type="radio"][name*="Size"]:checked, input[type="radio"][name*="size"]:checked, input[type="radio"]:checked');
    if (checked) return normalizeSize(checked.value);

    var select = root.querySelector('select[name*="Size"], select[name*="size"]');
    if (select) return normalizeSize(select.value);

    var selectedPill = root.querySelector('.product-form__input input[type="radio"]:checked + label, .product-form__input [aria-pressed="true"], .product-form__input .selected');
    return selectedPill ? normalizeSize(selectedPill.textContent) : '';
  }

  function parseVariantData(holder) {
    var raw = holder && (holder.getAttribute('data-dj-size-variants') || holder.getAttribute('data-variants'));
    if (!raw) return [];
    try {
      return JSON.parse(raw);
    } catch (error) {
      return [];
    }
  }

  function updateSizeStemHolder(holder) {
    if (!holder) return;

    var productRoot = holder.closest('.product') || document;
    var form = productRoot.querySelector('form[action*="/cart/add"]');
    var variantId = selectedVariantId(form);
    var size = selectedSizeValue(productRoot);
    var variants = parseVariantData(holder);
    var variantMatch = variants.find(function (item) {
      return String(item.id) === String(variantId);
    });

    if (variantMatch) {
      size = normalizeSize(variantMatch.size || size);
    }

    var stems = variantMatch && variantMatch.stems ? String(variantMatch.stems) : '';
    if (!stems && size && SIZE_STEM_FALLBACKS[size]) {
      stems = SIZE_STEM_FALLBACKS[size];
    }

    var output = holder.querySelector('[data-dj-size-stems-text]');
    if (!output) return;

    if (!size || !stems) {
      output.hidden = true;
      output.textContent = '';
      return;
    }

    var text = localeText();
    output.hidden = false;
    output.textContent = text.label + ' ' + size + ' — ' + stems + ' ' + text.stems;
  }

  function updateAllSizeStemLabels() {
    document.querySelectorAll('[data-dj-size-stems]').forEach(updateSizeStemHolder);
  }

  function parseMoneyToAed(text) {
    var matches = String(text || '').replace(/,/g, '').match(/\d+(?:\.\d+)?/g);
    if (!matches) return null;

    for (var i = 0; i < matches.length; i += 1) {
      var value = Number(matches[i]);
      if (Number.isFinite(value) && value > 0) return value;
    }

    return null;
  }

  function priceFromVariant(variant) {
    if (!variant) return null;
    var raw = variant.price || variant.price_cents || variant.priceCents;
    var value = Number(String(raw || '').replace(/[^\d.]/g, ''));
    if (!Number.isFinite(value) || value <= 0) return null;
    return value > 10000 ? value / 100 : value;
  }

  function findVariantInJsonScripts(variantId) {
    if (!variantId) return null;
    var scripts = document.querySelectorAll('script[type="application/json"]');

    for (var i = 0; i < scripts.length; i += 1) {
      var text = scripts[i].textContent || '';
      if (text.indexOf(String(variantId)) === -1 || text.indexOf('price') === -1) continue;

      try {
        var data = JSON.parse(text);
        var variants = [];

        if (Array.isArray(data)) {
          variants = data;
        } else if (data && Array.isArray(data.variants)) {
          variants = data.variants;
        } else if (data && data.product && Array.isArray(data.product.variants)) {
          variants = data.product.variants;
        }

        for (var j = 0; j < variants.length; j += 1) {
          if (String(variants[j].id) === String(variantId)) return variants[j];
        }
      } catch (error) {
        // Ignore non-product JSON scripts.
      }
    }

    return null;
  }

  function selectedVariantPriceAed(productRoot) {
    var form = productRoot.querySelector('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
    var variantId = selectedVariantId(form);
    var variant = findVariantInJsonScripts(variantId);
    var price = priceFromVariant(variant);

    if (price !== null) return price;

    if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
      var analyticsVariants = window.ShopifyAnalytics.meta.product.variants || [];
      for (var i = 0; i < analyticsVariants.length; i += 1) {
        if (String(analyticsVariants[i].id) === String(variantId)) {
          price = priceFromVariant(analyticsVariants[i]);
          if (price !== null) return price;
        }
      }
    }

    var selectedControl = productRoot.querySelector('input[type="radio"]:checked, select option:checked');
    if (selectedControl) {
      price = parseMoneyToAed(selectedControl.getAttribute('data-price') || selectedControl.getAttribute('data-variant-price'));
      if (price !== null) return price;
    }

    var priceNode = productRoot.querySelector('.product__info-container .price, .product__info-wrapper .price, .price.price--large, .price');
    return priceNode ? parseMoneyToAed(priceNode.textContent) : null;
  }

  function freeDeliveryText() {
    var lang = (document.documentElement.lang || 'en').toLowerCase();
    if (lang.indexOf('ar') === 0) {
      return {
        available: '\u0627\u0644\u062a\u0648\u0635\u064a\u0644 \u0627\u0644\u0645\u062c\u0627\u0646\u064a \u0645\u062a\u0627\u062d \u0644\u0647\u0630\u0627 \u0627\u0644\u0637\u0644\u0628.',
        add: '\u0623\u0636\u0641',
        more: '\u0623\u0643\u062b\u0631 \u0644\u0644\u062d\u0635\u0648\u0644 \u0639\u0644\u0649 \u062a\u0648\u0635\u064a\u0644 \u0645\u062c\u0627\u0646\u064a \u0641\u064a \u062f\u0628\u064a.'
      };
    }
    if (lang.indexOf('ru') === 0) {
      return {
        available: '\u0411\u0435\u0441\u043f\u043b\u0430\u0442\u043d\u0430\u044f \u0434\u043e\u0441\u0442\u0430\u0432\u043a\u0430 \u0434\u043e\u0441\u0442\u0443\u043f\u043d\u0430 \u0434\u043b\u044f \u044d\u0442\u043e\u0433\u043e \u0437\u0430\u043a\u0430\u0437\u0430.',
        add: '\u0414\u043e\u0431\u0430\u0432\u044c\u0442\u0435',
        more: '\u0435\u0449\u0435 \u0434\u043b\u044f \u0431\u0435\u0441\u043f\u043b\u0430\u0442\u043d\u043e\u0439 \u0434\u043e\u0441\u0442\u0430\u0432\u043a\u0438 \u043f\u043e \u0414\u0443\u0431\u0430\u044e.'
      };
    }
    return {
      available: 'Free delivery is available for this order.',
      add: 'Add',
      more: 'more to reach free delivery in Dubai.'
    };
  }

  /* DJ product free-delivery dirham-symbol patch 2026-07-10 */
  var DJ_DIRHAM_SYMBOL_HTML = "<span class=\"custom-currency dj-dirham-symbol\" aria-hidden=\"true\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 324.19 290.45\" focusable=\"false\"><path d=\"M324.19,196l-11.564-6.936-35.262.109c-4.33,19.185-12.015,36.87-24.215,52.285-52.205,65.958-150.381,44.876-223.958,48.532,2.849-4.499,5.761-8.708,7.763-13.727,1.821-4.565,5.237-16.258,5.237-20.763v-67.5c-.733-.266-1.196,1-1.5,1h-17c-.439,0-5.271-1.443-6.211-1.789C3.818,182.177-1.094,165.349.2,152c2.935,2.677,10.64,8,14.49,8h27.5v-29h-19.5c-2.219,0-9.47-3.846-11.523-5.477C1.752,118.046-.644,105.426.2,94c2.717,2.386,10.046,8,13.49,8h28.5V35.5c0-3.807-3.689-16.654-5.239-20.761-2.001-5.304-5.062-9.713-7.761-14.739,40.382,2.301,82.672-3.044,122.74,2.76,69.253,10.031,112.638,45.278,125.434,114.044l34.489.195c.664.102,1.288.27,1.875.481l10.461-6.481v85ZM139.69,29h-69.5v73h151.5C205.319,50.581,190.314,35.955,139.69,29ZM228.69,131H70.19v29h159.5c1.596-9.567,1.324-19.485-1-29ZM221.69,189H70.19v72h63.5c51.378,0,73.699-24.319,88-72Z\"></path></svg></span>";

  function formatAed(amount) {
    return Number(amount || 0).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function formatDirhamAmountHtml(amount) {
    return DJ_DIRHAM_SYMBOL_HTML + ' ' + formatAed(amount);
  }

  function rememberFreeDeliveryThreshold(widget, threshold) {
    if (!widget || !Number.isFinite(threshold) || threshold <= 0) return null;
    if (FREE_DELIVERY_THRESHOLDS) FREE_DELIVERY_THRESHOLDS.set(widget, threshold);
    widget.setAttribute('data-dj-threshold-aed', String(threshold));
    return threshold;
  }

  function freeDeliveryThresholdAed(widget, currentPrice) {
    var remembered = FREE_DELIVERY_THRESHOLDS ? FREE_DELIVERY_THRESHOLDS.get(widget) : null;
    if (Number.isFinite(remembered) && remembered > 0) return remembered;

    var explicit = parseMoneyToAed(widget.getAttribute('data-threshold-aed') || widget.dataset.thresholdAed);
    if (explicit !== null) return rememberFreeDeliveryThreshold(widget, explicit);

    var runtime = parseMoneyToAed(widget.getAttribute('data-dj-threshold-aed'));
    if (runtime !== null) return rememberFreeDeliveryThreshold(widget, runtime);

    var text = widget.querySelector('.dj-free-delivery-progress__text');
    var remaining = text ? parseMoneyToAed(text.textContent) : null;
    var bar = widget.querySelector('.dj-free-delivery-progress__bar');
    var barPercent = bar ? parseFloat(String(bar.style.width || '')) : null;

    if (remaining !== null && Number.isFinite(barPercent) && barPercent > 0 && barPercent < 100) {
      var thresholdFromProgress = remaining / (1 - (barPercent / 100));
      if (Number.isFinite(thresholdFromProgress) && thresholdFromProgress > 0) {
        thresholdFromProgress = Math.round(thresholdFromProgress / 50) * 50;
        return rememberFreeDeliveryThreshold(widget, thresholdFromProgress);
      }
    }

    if (remaining !== null && currentPrice !== null) {
      var threshold = currentPrice + remaining;
      return rememberFreeDeliveryThreshold(widget, threshold);
    }

    return null;
  }

  function updateFreeDeliveryProgressWidget(widget) {
    var productRoot = widget.closest('.product') || document.querySelector('.product') || document;
    var currentPrice = selectedVariantPriceAed(productRoot);
    if (currentPrice === null) return;

    var threshold = freeDeliveryThresholdAed(widget, currentPrice);
    if (threshold === null || threshold <= 0) return;

    var remaining = Math.max(threshold - currentPrice, 0);
    var percent = Math.max(0, Math.min(100, (currentPrice / threshold) * 100));
    var bar = widget.querySelector('.dj-free-delivery-progress__bar');
    var message = widget.querySelector('.dj-free-delivery-progress__text');
    var labels = freeDeliveryText();

    if (bar) bar.style.width = percent + '%';
    if (message) {
      if (remaining <= 0) {
        message.textContent = labels.available;
      } else {
        message.innerHTML = labels.add + ' ' + formatDirhamAmountHtml(remaining) + ' ' + labels.more;
      }
    }
    widget.classList.toggle('is-complete', remaining <= 0);
  }

  function updateAllFreeDeliveryProgress() {
    document.querySelectorAll('.dj-free-delivery-progress').forEach(updateFreeDeliveryProgressWidget);
  }

  function queueVariantUiUpdates() {
    window.setTimeout(function () {
      // updateAllSizeStemLabels();
      updateAllFreeDeliveryProgress();
    }, 0);
    window.setTimeout(function () {
      // updateAllSizeStemLabels();
      updateAllFreeDeliveryProgress();
    }, 120);
    window.setTimeout(updateAllFreeDeliveryProgress, 350);
    window.setTimeout(updateAllFreeDeliveryProgress, 800);
    window.setTimeout(updateAllFreeDeliveryProgress, 1400);
  }

  function layoutProductSupportBlocks() {
    document.querySelectorAll('.dj-product-support-below-media').forEach(function (support) {
      var conversion = support.querySelector('.dj-product-conversion');
      var isMobile = window.matchMedia('(max-width: 749px)').matches;
      var placeholder = document.querySelector('[data-dj-support-placeholder]');
      var infoWrapper = document.querySelector('.product__info-wrapper');
      var infoContainer = document.querySelector('.product__info-container');
      var productForm = infoContainer ? infoContainer.querySelector('.product-form') : null;
      var buyBlock = null;

      if (!placeholder) {
        placeholder = document.createElement('span');
        placeholder.hidden = true;
        placeholder.setAttribute('data-dj-support-placeholder', 'true');
        support.parentNode.insertBefore(placeholder, support);
      }

      if (productForm && infoContainer) {
        buyBlock = productForm;
        while (buyBlock.parentElement && buyBlock.parentElement !== infoContainer) {
          buyBlock = buyBlock.parentElement;
        }
      }

      if (isMobile && buyBlock && buyBlock.parentNode) {
        if (support.previousElementSibling !== buyBlock) {
          buyBlock.parentNode.insertBefore(support, buyBlock.nextSibling);
        }
      } else if (isMobile && infoWrapper && support.parentNode !== infoWrapper) {
        infoWrapper.appendChild(support);
      } else if (!isMobile && placeholder.parentNode && support.parentNode !== placeholder.parentNode) {
        placeholder.parentNode.insertBefore(support, placeholder.nextSibling);
      }

      support.style.setProperty('display', 'block', 'important');
      support.style.setProperty('position', 'relative', 'important');
      support.style.setProperty('top', 'auto', 'important');
      support.style.setProperty('right', 'auto', 'important');
      support.style.setProperty('bottom', 'auto', 'important');
      support.style.setProperty('left', 'auto', 'important');
      support.style.setProperty('inset', 'auto', 'important');
      support.style.setProperty('transform', 'none', 'important');
      support.style.setProperty('overflow', 'visible', 'important');
      support.style.setProperty('z-index', '3', 'important');
      support.style.setProperty('background', 'transparent', 'important');
      support.style.setProperty('clear', 'none', 'important');
      support.style.setProperty('flex', '0 0 100%', 'important');
      support.style.setProperty('flex-basis', '100%', 'important');
      support.style.setProperty('width', '100%', 'important');
      support.style.setProperty('max-width', '100%', 'important');
      support.style.setProperty('margin-top', '1.4rem', 'important');
      support.style.setProperty('margin-right', '0', 'important');
      support.style.setProperty('margin-inline-end', '0', 'important');
      support.classList.toggle('dj-product-support-below-info-mobile', isMobile);

      if (conversion) {
        conversion.style.setProperty('width', '100%', 'important');
        conversion.style.setProperty('max-width', '100%', 'important');
        conversion.style.setProperty('background', 'transparent', 'important');
        conversion.style.setProperty('border', '0', 'important');
        conversion.style.setProperty('box-shadow', 'none', 'important');
      }
    });
  }

  function setupRecentBouquetCarousel() {
    document.querySelectorAll('[data-dj-recent-carousel]').forEach(function (carousel) {
      if (carousel.dataset.djRecentReady === 'true') return;
      carousel.dataset.djRecentReady = 'true';

      var list = carousel.querySelector('[data-dj-recent-list]');
      if (!list) return;

      carousel.querySelectorAll('[data-dj-recent-direction]').forEach(function (button) {
        button.addEventListener('click', function () {
          var direction = button.getAttribute('data-dj-recent-direction') === 'prev' ? -1 : 1;
          var card = list.querySelector('.dj-product-conversion__recent-card');
          var step = card ? card.getBoundingClientRect().width + 20 : Math.round(list.clientWidth * 0.8);
          list.scrollBy({ left: direction * step, behavior: 'smooth' });
        });
      });
    });
  }

  function trimTrailingProductDescriptionBreaks() {
    function trimNodeTail(node) {
      var removed = false;
      var current = node.lastChild;

      while (current) {
        if (current.nodeType === Node.TEXT_NODE && current.textContent.trim() === '') {
          var previousText = current.previousSibling;
          current.remove();
          current = previousText;
          removed = true;
          continue;
        }

        if (current.nodeType === Node.ELEMENT_NODE && current.tagName === 'BR') {
          var previousBreak = current.previousSibling;
          current.remove();
          current = previousBreak;
          removed = true;
          continue;
        }

        if (current.nodeType === Node.ELEMENT_NODE && trimNodeTail(current)) {
          removed = true;
          if (current.textContent.trim() === '' && current.querySelector('img, video, iframe, svg, picture') === null) {
            var previousElement = current.previousSibling;
            current.remove();
            current = previousElement;
            continue;
          }
        }

        break;
      }

      return removed;
    }

    document.querySelectorAll('.product__description').forEach(function (description) {
      if (description.dataset.djDescriptionTrimmed === 'true') return;

      trimNodeTail(description);
      description.dataset.djDescriptionTrimmed = 'true';
    });
  }

  function styleOpenSizeGuide(guide) {
    if (!guide || !guide.hasAttribute('open')) return;

    var panel = guide.querySelector('.dj-product-size-guide__panel');
    if (!panel) return;

    var isMobile = window.matchMedia('(max-width: 749px)').matches;
    document.documentElement.classList.add('dj-size-guide-open');

    panel.style.position = 'fixed';
    panel.style.top = '50%';
    panel.style.left = '50%';
    panel.style.right = 'auto';
    panel.style.bottom = 'auto';
    panel.style.transform = 'translate(-50%, -50%)';
    panel.style.zIndex = '10091';
    panel.style.width = isMobile ? 'calc(100vw - 2.4rem)' : 'min(68rem, calc(100vw - 4rem))';
    panel.style.maxWidth = isMobile ? 'calc(100vw - 2.4rem)' : 'min(68rem, calc(100vw - 4rem))';
    panel.style.maxHeight = isMobile ? 'calc(100dvh - 2.4rem)' : 'min(78rem, calc(100dvh - 4rem))';
    panel.style.overflowY = 'auto';
    panel.style.margin = '0';
  }

  function cleanupSizeGuideState() {
    if (!document.querySelector('[data-dj-product-size-guide][open]')) {
      document.documentElement.classList.remove('dj-size-guide-open');
    }
  }

  function centerOpenSizeGuides() {
    document.querySelectorAll('[data-dj-product-size-guide][open]').forEach(styleOpenSizeGuide);
    cleanupSizeGuideState();
  }

  function closeOtherSizeGuides(currentGuide) {
    document.querySelectorAll('[data-dj-product-size-guide][open]').forEach(function (guide) {
      if (guide !== currentGuide) {
        guide.removeAttribute('open');
      }
    });
  }

  document.addEventListener('change', function (event) {
    if (event.target.matches('input[type="radio"], select, [name="id"]')) {
      queueVariantUiUpdates();
    }
  }, true);

  document.addEventListener('click', function (event) {
    if (event.target.closest('.product-form__input label, variant-radios label, variant-selects label')) {
      queueVariantUiUpdates();
    }
  }, true);

  document.addEventListener('variant:change', queueVariantUiUpdates);
  document.addEventListener('DOMContentLoaded', queueVariantUiUpdates);
  document.addEventListener('DOMContentLoaded', trimTrailingProductDescriptionBreaks);
  window.addEventListener('pageshow', queueVariantUiUpdates);
  window.addEventListener('pageshow', trimTrailingProductDescriptionBreaks);
  document.addEventListener('DOMContentLoaded', layoutProductSupportBlocks);
  document.addEventListener('DOMContentLoaded', setupRecentBouquetCarousel);
  window.addEventListener('pageshow', layoutProductSupportBlocks);
  window.addEventListener('pageshow', setupRecentBouquetCarousel);
  window.addEventListener('resize', function () {
    window.requestAnimationFrame(layoutProductSupportBlocks);
  });
  window.setTimeout(layoutProductSupportBlocks, 300);
  window.setTimeout(layoutProductSupportBlocks, 1200);
  window.setTimeout(trimTrailingProductDescriptionBreaks, 300);
  window.setTimeout(trimTrailingProductDescriptionBreaks, 1200);

  document.addEventListener('click', function (event) {
    var closeButton = event.target.closest('[data-dj-size-guide-close]');
    if (closeButton) {
      var guideToClose = closeButton.closest('[data-dj-product-size-guide]');
      if (guideToClose) guideToClose.removeAttribute('open');
      window.setTimeout(cleanupSizeGuideState, 0);
      return;
    }

    var trigger = event.target.closest('[data-dj-product-size-guide] summary, .dj-product-size-guide__trigger');
    if (trigger) {
      var currentGuide = trigger.closest('[data-dj-product-size-guide]');
      closeOtherSizeGuides(currentGuide);
      window.setTimeout(centerOpenSizeGuides, 0);
      window.setTimeout(centerOpenSizeGuides, 120);
      window.setTimeout(centerOpenSizeGuides, 350);
      return;
    }

    document.querySelectorAll('[data-dj-product-size-guide][open]').forEach(function (guide) {
      var panel = guide.querySelector('.dj-product-size-guide__panel');
      if (panel && !panel.contains(event.target)) {
        guide.removeAttribute('open');
      }
    });
    window.setTimeout(cleanupSizeGuideState, 0);
  }, true);

  document.addEventListener('toggle', function (event) {
    if (!event.target.matches('[data-dj-product-size-guide]')) return;
    if (event.target.hasAttribute('open')) {
      closeOtherSizeGuides(event.target);
      window.setTimeout(centerOpenSizeGuides, 0);
      window.setTimeout(centerOpenSizeGuides, 120);
    } else {
      window.setTimeout(cleanupSizeGuideState, 0);
    }
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-dj-product-size-guide][open]').forEach(function (guide) {
      guide.removeAttribute('open');
    });
    cleanupSizeGuideState();
  });
})();

// dj cache bust 2026-07-02 product layout final

(function () {
  function currentLocale() {
    return (document.documentElement.getAttribute('lang') || document.body.getAttribute('lang') || 'en').toLowerCase();
  }

  function photoLabel(count) {
    var locale = currentLocale();
    if (locale.indexOf('ar') === 0) return count + ' صور';
    if (locale.indexOf('ru') === 0) return count + ' фото';
    return count + ' photos';
  }

  function videoLabel() {
    var locale = currentLocale();
    if (locale.indexOf('ar') === 0) return 'فيديو';
    if (locale.indexOf('ru') === 0) return 'Видео';
    return 'Video';
  }

  function rawMediaIdFromThumbnail(item) {
    var target = item.getAttribute('data-target');
    var button = item.querySelector('[data-target]');
    target = target || (button && button.getAttribute('data-target'));
    if (!target) return '';
    var id = target.replace(/^#/, '');
    var parts = id.split('-');
    return parts[parts.length - 1] || id;
  }

  function setProductGalleryBadges(scope) {
    (scope || document).querySelectorAll('.product__media-wrapper media-gallery').forEach(function (gallery) {
      var items = Array.prototype.slice.call(gallery.querySelectorAll('.thumbnail-list__item'));
      if (!items.length) return;

      items.forEach(function (item) {
        item.removeAttribute('data-dj-photo-count');
        item.removeAttribute('data-dj-video-label');
      });

      var firstTwo = items.slice(0, 2);
      var videoTile = firstTwo.find(function (item) {
        var text = item.textContent || '';
        return /video/i.test(text) || item.querySelector('.icon-play, svg.icon-play, deferred-media, [class*="deferred-media"]');
      });

      if (videoTile) {
        videoTile.setAttribute('data-dj-video-label', videoLabel());
      }

      var countTile = firstTwo[1] || firstTwo[0];
      if (countTile) {
        countTile.setAttribute('data-dj-photo-count', photoLabel(items.length));
      }
    });
  }

  function openGalleryModalFromTile(item) {
    var gallery = item.closest('media-gallery');
    if (!gallery) return;
    var rawId = rawMediaIdFromThumbnail(item);
    var opener = rawId ? gallery.querySelector('.product__media-toggle[data-media-id="' + rawId + '"], modal-opener button[data-media-id="' + rawId + '"]') : null;
    var fallback = gallery.querySelector('.product__media-item.is-active .product__media-toggle, .product__media-item.is-active modal-opener button, .product__media-item .product__media-toggle, .product__media-item modal-opener button');
    var button = opener || fallback;
    if (button) button.click();
  }

  document.addEventListener('DOMContentLoaded', function () {
    setProductGalleryBadges(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    setProductGalleryBadges(event.target);
  });

  window.addEventListener('pageshow', function () {
    setProductGalleryBadges(document);
  });

  document.addEventListener('click', function (event) {
    if (window.innerWidth > 749) return;
    var item = event.target.closest('.product__media-wrapper .thumbnail-list__item[data-dj-photo-count], .product__media-wrapper .thumbnail-list__item[data-dj-video-label]');
    if (!item) return;
    event.preventDefault();
    event.stopPropagation();
    openGalleryModalFromTile(item);
  }, true);
})();

// dj cache bust 2026-07-03 live-style mobile product gallery

(function () {
  function localeFromPath() {
    if (window.location.pathname.indexOf('/ar/') === 0) return 'ar';
    if (window.location.pathname.indexOf('/ru/') === 0) return 'ru';
    return 'en';
  }

  function articleLocaleLabels(locale) {
    if (locale === 'ar') {
      return {
        toc: '\u0641\u064a \u0647\u0630\u0627 \u0627\u0644\u062f\u0644\u064a\u0644',
        back: '\u0627\u0644\u0639\u0648\u062f\u0629 \u0625\u0644\u0649 \u0627\u0644\u0645\u062f\u0648\u0646\u0629',
        recent: '\u0623\u062d\u062f\u062b \u0623\u062f\u0644\u0629 \u0627\u0644\u0632\u0647\u0648\u0631',
        topics: '\u0645\u0648\u0636\u0648\u0639\u0627\u062a \u0627\u0644\u0645\u0642\u0627\u0644',
        tags: ['\u062f\u0644\u064a\u0644 \u0627\u0644\u0632\u0647\u0648\u0631', '\u0632\u0647\u0648\u0631']
      };
    }
    if (locale === 'ru') {
      return {
        toc: '\u0412 \u044d\u0442\u043e\u043c \u0440\u0443\u043a\u043e\u0432\u043e\u0434\u0441\u0442\u0432\u0435',
        back: '\u041d\u0430\u0437\u0430\u0434 \u043a \u0431\u043b\u043e\u0433\u0443',
        recent: '\u041f\u043e\u0441\u043b\u0435\u0434\u043d\u0438\u0435 \u043c\u0430\u0442\u0435\u0440\u0438\u0430\u043b\u044b \u043e \u0446\u0432\u0435\u0442\u0430\u0445',
        topics: '\u0422\u0435\u043c\u044b \u0441\u0442\u0430\u0442\u044c\u0438',
        tags: ['\u0433\u0438\u0434 \u043f\u043e \u0446\u0432\u0435\u0442\u0430\u043c', '\u0446\u0432\u0435\u0442\u044b']
      };
    }
    return null;
  }

  function replaceText(selector, value) {
    document.querySelectorAll(selector).forEach(function (node) {
      if (node && value) node.textContent = value;
    });
  }

  function normalizeArticleTocAnchors() {
    var tocLinks = Array.prototype.slice.call(document.querySelectorAll('.dj-article-toc__link'));
    if (!tocLinks.length) return;

    var headings = Array.prototype.slice.call(document.querySelectorAll('main h2, main h3')).filter(function (heading) {
      return !heading.closest('.dj-article-toc') && !heading.closest('.dj-article-support') && !heading.closest('footer');
    });

    headings.forEach(function (heading, index) {
      heading.id = 'article-section-' + (index + 1);
    });

    tocLinks.forEach(function (link, index) {
      link.setAttribute('href', '#article-section-' + (index + 1));
    });
  }

  function fixArticleLocaleUi() {
    if (!/\/(?:ar|ru)\/blogs\//.test(window.location.pathname)) return;
    var labels = articleLocaleLabels(localeFromPath());
    if (!labels) return;

    replaceText('.dj-article-toc__title', labels.toc);
    document.querySelectorAll('.dj-article-toc').forEach(function (toc) {
      toc.setAttribute('aria-label', labels.toc);
    });
    replaceText('.dj-article-back a', labels.back);

    var supportTitles = document.querySelectorAll('.dj-article-support__title');
    if (supportTitles[0]) supportTitles[0].textContent = labels.recent;
    if (supportTitles[1]) supportTitles[1].textContent = labels.topics;

    document.querySelectorAll('.dj-article-support__tag').forEach(function (tag, index) {
      tag.textContent = labels.tags[index % labels.tags.length];
    });

    normalizeArticleTocAnchors();
  }

  document.addEventListener('DOMContentLoaded', function () {
    fixArticleLocaleUi();
    window.setTimeout(fixArticleLocaleUi, 250);
    window.setTimeout(fixArticleLocaleUi, 1000);
  });

  window.addEventListener('pageshow', function () {
    fixArticleLocaleUi();
    window.setTimeout(fixArticleLocaleUi, 250);
  });
})();

(function () {
  if (!/\/(?:ar|ru)\/blogs\//.test(window.location.pathname)) return;

  var isArabic = window.location.pathname.indexOf('/ar/') === 0;
  var labels = isArabic ? {
    toc: '\u0641\u064a \u0647\u0630\u0627 \u0627\u0644\u062f\u0644\u064a\u0644',
    back: '\u0627\u0644\u0639\u0648\u062f\u0629 \u0625\u0644\u0649 \u0627\u0644\u0645\u062f\u0648\u0646\u0629',
    recent: '\u0623\u062d\u062f\u062b \u0623\u062f\u0644\u0629 \u0627\u0644\u0632\u0647\u0648\u0631',
    topics: '\u0645\u0648\u0636\u0648\u0639\u0627\u062a \u0627\u0644\u0645\u0642\u0627\u0644',
    tags: ['\u062f\u0644\u064a\u0644 \u0627\u0644\u0632\u0647\u0648\u0631', '\u0632\u0647\u0648\u0631']
  } : {
    toc: '\u0412 \u044d\u0442\u043e\u043c \u0440\u0443\u043a\u043e\u0432\u043e\u0434\u0441\u0442\u0432\u0435',
    back: '\u041d\u0430\u0437\u0430\u0434 \u043a \u0431\u043b\u043e\u0433\u0443',
    recent: '\u041f\u043e\u0441\u043b\u0435\u0434\u043d\u0438\u0435 \u043c\u0430\u0442\u0435\u0440\u0438\u0430\u043b\u044b \u043e \u0446\u0432\u0435\u0442\u0430\u0445',
    topics: '\u0422\u0435\u043c\u044b \u0441\u0442\u0430\u0442\u044c\u0438',
    tags: ['\u0433\u0438\u0434 \u043f\u043e \u0446\u0432\u0435\u0442\u0430\u043c', '\u0446\u0432\u0435\u0442\u044b']
  };

  function setText(selector, value) {
    document.querySelectorAll(selector).forEach(function (node) {
      node.textContent = value;
    });
  }

  function fixVisibleArticleChrome() {
    setText('.dj-article-toc__title', labels.toc);
    document.querySelectorAll('.dj-article-toc').forEach(function (toc) {
      toc.setAttribute('aria-label', labels.toc);
    });
    setText('.dj-article-back a', labels.back);

    var supportTitles = document.querySelectorAll('.dj-article-support__title');
    if (supportTitles[0]) supportTitles[0].textContent = labels.recent;
    if (supportTitles[1]) supportTitles[1].textContent = labels.topics;

    document.querySelectorAll('.dj-article-support__tag').forEach(function (tag, index) {
      tag.textContent = labels.tags[index % labels.tags.length];
    });

    var tocLinks = Array.prototype.slice.call(document.querySelectorAll('.dj-article-toc__link'));
    var headings = Array.prototype.slice.call(document.querySelectorAll('main h2, main h3')).filter(function (heading) {
      return !heading.closest('.dj-article-toc') && !heading.closest('.dj-article-support') && !heading.closest('footer');
    });

    headings.forEach(function (heading, index) {
      heading.id = 'article-section-' + (index + 1);
    });
    tocLinks.forEach(function (link, index) {
      link.setAttribute('href', '#article-section-' + (index + 1));
    });
  }

  function scheduleFixes() {
    fixVisibleArticleChrome();
    [100, 300, 700, 1500, 3000, 6000, 10000, 15000].forEach(function (delay) {
      window.setTimeout(fixVisibleArticleChrome, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleFixes);
  } else {
    scheduleFixes();
  }

  var observer = new MutationObserver(function () {
    window.clearTimeout(observer._djArticleFixTimer);
    observer._djArticleFixTimer = window.setTimeout(fixVisibleArticleChrome, 60);
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['href', 'id']
  });

  var repeatCount = 0;
  var repeatTimer = window.setInterval(function () {
    fixVisibleArticleChrome();
    repeatCount += 1;
    if (repeatCount >= 20) window.clearInterval(repeatTimer);
  }, 750);
})();
